import { resolveAbilityId } from "../catalogs/characterSystemCatalog";
export function signed(value) {
  return value >= 0 ? `+${value}` : `${value}`;
}

export function calculateSkillBonus(characteristics, skill) {
  const linkedAbility = characteristics.mainCharacteristicList.find(
    (item) => resolveAbilityId(item.abilityId || item.name) === resolveAbilityId(skill.abilityId || skill.mainCharacteristicName)
  );
  const abilityModifier = linkedAbility ? Math.floor((Number(linkedAbility.diceValue) - 10) / 2) : 0;
  const ranks = Number(skill.playerSkillPoints) || 0;
  const classSkillBonus = skill.isClassSkill && ranks > 0 ? 3 : 0;
  const otherBonus = Number(skill.modifier) || 0;
  const ruleBonus = Number(skill.ruleBonus) || 0;

  return { abilityModifier, ranks, classSkillBonus, otherBonus, ruleBonus, total: abilityModifier + ranks + classSkillBonus + otherBonus + ruleBonus };
}
